<template>
  <email-form-modal
    :modal-id="modalId"
    :title="`Email Invoice ${value.number}`"
    help-text="Enter one or more emails to send the Invoice to"
    :initial-emails="initialEmails"
    :initial-form="initialForm"
    :request="submitRequest"
    @success="(invoice) => $emit('input', invoice)"
  >
    <template #fields="{ form }">
      <b-row>
        <b-col
          cols="12"
          v-if="!value.emailed_at"
        >
          <b-form-group label-for="invoice-email-mark_emailed_at">
            <b-form-checkbox
              id="invoice-email-mark_emailed_at"
              v-model="form.mark_emailed_at"
            >
              Mark as auto-emailed
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </template>
  </email-form-modal>
</template>

<script>
import EmailFormModal from '@/components/shared/EmailFormModal.vue';

export default {
  name: 'InvoicesEmailModal',
  components: {
    EmailFormModal,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    mark_emailed_at: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      modalId: 'invoice-email-modal',
    };
  },
  computed: {
    initialEmails() {
      const billingEmails = Array.isArray(this.value.billing_emails) ? this.value.billing_emails : [];
      const emails = billingEmails
        .map(item => (typeof item === 'string' ? item.trim() : ''))
        .filter(item => item.length);
      return emails.length ? emails : [this.$store.getters.user.email];
    },
    initialForm() {
      return {
        mark_emailed_at: this.mark_emailed_at,
      };
    },
  },
  methods: {
    submitRequest(payload) {
      return this.$invoicesAPI.email(this.value.id, payload);
    },
  },
};
</script>
